export default __webpack_public_path__ + "static/media/Custom-HUD-06.5020a8a8.jpg";